<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    functional: true,
    props: {
        label: {
            type: String,
            required: false
        }
    },
    render: function (createElement, context) {

        const children = []
        if (context.props.label) {
            children.push(createElement('legend', {staticClass: 'global-filter-group__label'}, [context.props.label]))
        }

        context.children.forEach(child => {
            if (child.componentOptions?.tag) {
                children.push(createElement('div', {staticClass: 'global-filter-group__item col-12 col-md-3'}, [child]))
            }
        })

        return createElement('fieldset', {staticClass: 'global-filter-group row'}, children)
    }
})
</script>
